import { jsx as _jsx } from "react/jsx-runtime";
import { THEME_SEED } from "./theme-seed";
/**
 * Pre-hydration theme seed — reads the SHARED owlcat-theme cookie (set
 * parent-domain by any sibling app) and primes localStorage + the `.dark` class
 * so there is NO flash and the theme choice carries across the fleet.
 *
 * A plain inline <script>, server-rendered as the first body child of a ROOT
 * LAYOUT: it is in the HTML document before hydration, so the browser runs it
 * before next-themes mounts.
 *
 * DEPRECATED — React 19.2 refuses to create a <script> element on the client at
 * all (react-dom swaps it for a <div> and logs "Encountered a script tag while
 * rendering React component"), and the check covers every form: inline children,
 * `dangerouslySetInnerHTML`, next/script, a server component or a client one. The
 * warning is development-only and the seed still runs from the server HTML, so
 * nothing is broken — it is just noise with no way to silence it.
 *
 * Prefer the script-free path: read the cookie in the root layout with
 * `parseThemeCookie`, put the matching class on <html>, and pass the same value to
 * `ThemeProvider initialTheme`. See src/party/app/layout.tsx. This component stays
 * for the apps that have not moved yet.
 *
 * NOT next/script. `next/script` is a client component, so React created the
 * script element on the client and react-dom logged "Encountered a script tag
 * while rendering React component" — that warning fires on the create-instance
 * path for ANY <script>, whatever its props, and `dangerouslySetInnerHTML` does
 * not silence it. Server-rendered markup is hydrated, never created, so this
 * form does not warn. Keep it in a SERVER component: rendering it inside a
 * client tree brings the warning straight back, and the seed would run too late
 * to matter anyway.
 *
 * Usage in a root layout, as the first body child:
 *   <body>
 *     <ThemeSeed />
 *     <ThemeProvider locales={locales}>{children}</ThemeProvider>
 *   </body>
 */
export function ThemeSeed() {
    return _jsx("script", { id: "owlcat-theme-seed", suppressHydrationWarning: true, dangerouslySetInnerHTML: { __html: THEME_SEED } });
}
